import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import { ChipClickable } from '../../../Chips';
import { startCopyBid } from '../../../../store/actions/bids';
import { selectBidTemplates } from '../../../../store/selectors';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
});

const Bids = ({ classes, bid, bidTemplates, startCopyBid }) => {
  return(
    <div className={classes.root}>
      {bidTemplates.map((bidTemplate) =>
        <ChipClickable
          key={bidTemplate.id}
          label={bidTemplate.code}
          handleClick={() => {
            startCopyBid(bid.id, bidTemplate.id)
          }}/>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bid: state.bidsState.find( bid => bid.id === state.adminState.bid.id ),
    bidTemplates: selectBidTemplates(state)
  }
};

const mapDispatchToProps = (dispatch) => ({
  startCopyBid: (destinationBidId, sourceBidId) => dispatch(startCopyBid(destinationBidId, sourceBidId))
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Bids);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Header/Bids.jsx